
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire13a7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire13a7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dpnMS", function(module, exports) {

$parcel$export(module.exports, "BigJsonViewerService", () => $5a6657ab2d9f6108$export$8df78c6654d8a3cf);

var $jl3no = parcelRequire("jl3no");

var $bjTst = parcelRequire("bjTst");

var $7vO2F = parcelRequire("7vO2F");
class $5a6657ab2d9f6108$export$8df78c6654d8a3cf {
    initWithData(data) {
        this.rootNode = new (0, $bjTst.BufferJsonParser)(data).getRootNodeInfo();
        return this.getRenderInfo(this.rootNode);
    }
    initWithJs(data) {
        this.rootNode = new (0, $7vO2F.JsParser)(data).getRootNodeInfo();
        return this.getRenderInfo(this.rootNode);
    }
    getNodes(path, start, limit) {
        const node = this.rootNode.getByPath(path);
        if (node && node.type === 'object') return node.getObjectNodes(start, limit).map((n)=>this.getRenderInfo(n));
        if (node && node.type === 'array') return node.getArrayNodes(start, limit).map((n)=>this.getRenderInfo(n));
        return null;
    }
    getKeyIndex(path, key) {
        const node = this.rootNode.getByPath(path);
        if (!node) return -1;
        const keys = node.getObjectKeys();
        return keys.indexOf(key);
    }
    search(pattern, searchArea) {
        return (0, $jl3no.searchJsonNodes)(this.rootNode, pattern, searchArea);
    }
    getRenderInfo(node) {
        const info = {
            type: node.type,
            length: node.length,
            path: node.path,
            openable: this.isOpenableNode(node)
        };
        if (!info.openable) info.value = node.getValue();
        return info;
    }
    isOpenableNode(node) {
        return (node.type === 'array' || node.type === 'object') && !!node.length;
    }
}

});
parcelRegister("jl3no", function(module, exports) {

$parcel$export(module.exports, "searchJsonNodes", () => $8d78a578d08ef2f3$export$e47f93b04bb8867c);
$parcel$export(module.exports, "forEachMatchFromString", () => $8d78a578d08ef2f3$export$57f00ad7da2077f5);
function $8d78a578d08ef2f3$export$e47f93b04bb8867c(node, pattern, searchArea = 'all') {
    pattern = $8d78a578d08ef2f3$var$ensureGlobal(pattern);
    const results = [];
    if (node.path.length && (searchArea === 'all' || searchArea === 'keys')) $8d78a578d08ef2f3$export$57f00ad7da2077f5(pattern, node.path[node.path.length - 1], (index, length)=>{
        results.push({
            path: node.path,
            key: index,
            length: length
        });
    });
    if (node.type === 'object') node.getObjectNodes().forEach((subNode)=>{
        results.push(...$8d78a578d08ef2f3$export$e47f93b04bb8867c(subNode, pattern, searchArea));
    });
    else if (node.type === 'array') node.getArrayNodes().forEach((subNode)=>{
        results.push(...$8d78a578d08ef2f3$export$e47f93b04bb8867c(subNode, pattern, searchArea));
    });
    else if (searchArea === 'all' || searchArea === 'values') $8d78a578d08ef2f3$export$57f00ad7da2077f5(pattern, String(node.getValue()), (index, length)=>{
        results.push({
            path: node.path,
            value: index,
            length: length
        });
    });
    return results;
}
function $8d78a578d08ef2f3$export$57f00ad7da2077f5(pattern, subject, callback) {
    pattern = $8d78a578d08ef2f3$var$ensureGlobal(pattern);
    pattern.lastIndex = 0;
    let match = null;
    while((match = pattern.exec(subject)) !== null)callback(match.index, match[0].length);
    pattern.lastIndex = 0;
}
function $8d78a578d08ef2f3$var$ensureGlobal(pattern) {
    if (!pattern.global) {
        const flags = 'g' + (pattern.ignoreCase ? 'i' : '') + (pattern.multiline ? 'm' : '');
        return new RegExp(pattern.source, flags);
    }
    return pattern;
}

});

parcelRegister("bjTst", function(module, exports) {

$parcel$export(module.exports, "BufferJsonParser", () => $8b51f9b9b5b272ca$export$8563104a25517665);

var $3NxB6 = parcelRequire("3NxB6");
const $8b51f9b9b5b272ca$var$BRACE_START = '{'.charCodeAt(0);
const $8b51f9b9b5b272ca$var$BRACE_END = '}'.charCodeAt(0);
const $8b51f9b9b5b272ca$var$BRACKET_START = '['.charCodeAt(0);
const $8b51f9b9b5b272ca$var$BRACKET_END = ']'.charCodeAt(0);
const $8b51f9b9b5b272ca$var$COLON = ':'.charCodeAt(0);
const $8b51f9b9b5b272ca$var$COMMA = ','.charCodeAt(0);
const $8b51f9b9b5b272ca$var$DOUBLE_QUOTE = '"'.charCodeAt(0);
const $8b51f9b9b5b272ca$var$SINGLE_QUOTE = "'".charCodeAt(0);
const $8b51f9b9b5b272ca$var$SPACE = ' '.charCodeAt(0);
const $8b51f9b9b5b272ca$var$TAB = '\t'.charCodeAt(0);
const $8b51f9b9b5b272ca$var$NEWLINE = '\n'.charCodeAt(0);
const $8b51f9b9b5b272ca$var$BACKSPACE = '\b'.charCodeAt(0);
const $8b51f9b9b5b272ca$var$CARRIAGE_RETURN = '\r'.charCodeAt(0);
const $8b51f9b9b5b272ca$var$FORM_FEED = '\f'.charCodeAt(0);
const $8b51f9b9b5b272ca$var$BACK_SLASH = '\\'.charCodeAt(0);
const $8b51f9b9b5b272ca$var$FORWARD_SLASH = '/'.charCodeAt(0);
const $8b51f9b9b5b272ca$var$MINUS = '-'.charCodeAt(0);
const $8b51f9b9b5b272ca$var$PLUS = '+'.charCodeAt(0);
const $8b51f9b9b5b272ca$var$DOT = '.'.charCodeAt(0);
const $8b51f9b9b5b272ca$var$CHAR_E_LOW = 'e'.charCodeAt(0);
const $8b51f9b9b5b272ca$var$CHAR_E_HIGH = 'E'.charCodeAt(0);
const $8b51f9b9b5b272ca$var$DIGIT_0 = '0'.charCodeAt(0);
const $8b51f9b9b5b272ca$var$DIGIT_9 = '9'.charCodeAt(0);
const $8b51f9b9b5b272ca$var$IGNORED = [
    $8b51f9b9b5b272ca$var$SPACE,
    $8b51f9b9b5b272ca$var$TAB,
    $8b51f9b9b5b272ca$var$NEWLINE,
    $8b51f9b9b5b272ca$var$CARRIAGE_RETURN
];
const $8b51f9b9b5b272ca$var$NULL = 'null'.split('').map((d)=>d.charCodeAt(0));
const $8b51f9b9b5b272ca$var$TRUE = 'true'.split('').map((d)=>d.charCodeAt(0));
const $8b51f9b9b5b272ca$var$FALSE = 'false'.split('').map((d)=>d.charCodeAt(0));
class $8b51f9b9b5b272ca$export$c3a21231378bfea9 {
    constructor(parser, index, path){
        this.path = [];
        this.parser = parser;
        this.index = index;
        this.path = path;
    }
    /**
   * Returns the list of keys in case of an object for the defined range
   * @param {number} start
   * @param {number} limit
   */ getObjectKeys(start = 0, limit) {
        if (this.type !== 'object') throw new Error(`Unsupported method on non-object ${this.type}`);
        (0, $3NxB6.assertStartLimit)(start, limit);
        const ctx = {
            path: this.path,
            objectKeys: [],
            start: start,
            limit: limit
        };
        this.parser.parseObject(this.index, ctx);
        return ctx.objectKeys;
    }
    /**
   * Return the NodeInfo at the defined position.
   * Use the index from getObjectKeys
   * @param index
   */ getByIndex(index) {
        if (this.type === 'object') {
            const nodes = this.getObjectNodes(index, 1);
            if (nodes.length) return nodes[0];
        }
        if (this.type === 'array') {
            const nodes = this.getArrayNodes(index, 1);
            if (nodes.length) return nodes[0];
        }
        return undefined;
    }
    /**
   * Return the NodeInfo for the specified key
   * Use the index from getObjectKeys
   * @param key
   */ getByKey(key) {
        if (this.type === 'object') {
            const ctx = {
                path: this.path,
                objectKey: key
            };
            this.parser.parseObject(this.index, ctx);
            return ctx.objectNodes ? ctx.objectNodes[0] : undefined;
        }
        if (this.type === 'array') return this.getByIndex(parseInt(key));
        return undefined;
    }
    /**
   * Find the information for a given path
   * @param {string[]} path
   */ getByPath(path) {
        if (!path) return undefined;
        if (!path.length) return this;
        const p = path.slice();
        let key;
        let node = this;
        while((key = p.shift()) !== undefined && node)node = node.getByKey(key);
        return node;
    }
    /**
   * Returns a list with the NodeInfo objects for the defined range
   * @param {number} start
   * @param {number} limit
   */ getObjectNodes(start = 0, limit) {
        if (this.type !== 'object') throw new Error(`Unsupported method on non-object ${this.type}`);
        (0, $3NxB6.assertStartLimit)(start, limit);
        const ctx = {
            path: this.path,
            objectNodes: [],
            start: start,
            limit: limit
        };
        this.parser.parseObject(this.index, ctx);
        return ctx.objectNodes;
    }
    /**
   * Returns a list of NodeInfo for the defined range
   * @param {number} start
   * @param {number} limit
   */ getArrayNodes(start = 0, limit) {
        if (this.type !== 'array') throw new Error(`Unsupported method on non-array ${this.type}`);
        (0, $3NxB6.assertStartLimit)(start, limit);
        const ctx = {
            path: this.path,
            arrayNodes: [],
            start: start,
            limit: limit
        };
        this.parser.parseArray(this.index, ctx);
        return ctx.arrayNodes;
    }
    /**
   * Get the natively parsed value
   */ getValue() {
        return this.parser.parseNative(this.index, this.index + this.chars);
    }
}
class $8b51f9b9b5b272ca$export$8563104a25517665 {
    constructor(data){
        if (data instanceof ArrayBuffer) this.data = new Uint16Array(data);
        else if (typeof data === 'string' && typeof TextEncoder !== 'undefined') this.data = new TextEncoder().encode(data);
        else if (typeof data === 'string') {
            this.data = new Uint16Array(new ArrayBuffer(data.length * 2));
            for(let i = 0; i < data.length; i++)this.data[i] = data.charCodeAt(i);
        }
    }
    getRootNodeInfo() {
        let start = this.skipIgnored(0);
        const ctx = {
            path: [],
            nodeInfo: new $8b51f9b9b5b272ca$export$c3a21231378bfea9(this, start, [])
        };
        const end = this.parseValue(start, ctx, false);
        if (start === end) return null;
        return ctx.nodeInfo;
    }
    parseValue(start, ctx, throwUnknown = true) {
        const char = this.data[start];
        if (isString(char)) return this.parseString(start, ctx);
        if (isNumber(char)) return this.parseNumber(start, ctx);
        if (char === $8b51f9b9b5b272ca$var$BRACE_START) return this.parseObject(start, ctx);
        if (char === $8b51f9b9b5b272ca$var$BRACKET_START) return this.parseArray(start, ctx);
        if (char === $8b51f9b9b5b272ca$var$TRUE[0]) return this.parseToken(start, $8b51f9b9b5b272ca$var$TRUE, ctx);
        if (char === $8b51f9b9b5b272ca$var$FALSE[0]) return this.parseToken(start, $8b51f9b9b5b272ca$var$FALSE, ctx);
        if (char === $8b51f9b9b5b272ca$var$NULL[0]) return this.parseToken(start, $8b51f9b9b5b272ca$var$NULL, ctx);
        if (throwUnknown) throw new Error(`parse value unknown token ${$8b51f9b9b5b272ca$var$bufToString(char)} at ${start}`);
        function isString(char) {
            return char === $8b51f9b9b5b272ca$var$DOUBLE_QUOTE || char === $8b51f9b9b5b272ca$var$SINGLE_QUOTE;
        }
        function isNumber(char) {
            return char === $8b51f9b9b5b272ca$var$MINUS || char >= $8b51f9b9b5b272ca$var$DIGIT_0 && char <= $8b51f9b9b5b272ca$var$DIGIT_9;
        }
    }
    parseObject(start, ctx) {
        let index = start + 1; // skip the start brace
        let length = 0;
        const keys = [];
        const nodes = [];
        while(index <= this.data.length){
            if (index === this.data.length) throw new Error(`parse object incomplete at end`);
            index = this.skipIgnored(index);
            if (this.data[index] === $8b51f9b9b5b272ca$var$BRACE_END) {
                index++;
                break;
            }
            const keyCtx = getKeyContext(length);
            index = this.parseString(index, keyCtx);
            if (keyCtx && ctx && ctx.objectKeys) keys.push(keyCtx.value);
            index = this.skipIgnored(index);
            if (this.data[index] !== $8b51f9b9b5b272ca$var$COLON) throw new Error(`parse object unexpected token ${$8b51f9b9b5b272ca$var$bufToString(this.data[index])} at ${index}. Expected :`);
            else index++;
            index = this.skipIgnored(index);
            let valueCtx = null;
            if (keyCtx && ctx && (ctx.objectNodes || keyCtx.value === ctx.objectKey)) valueCtx = {
                path: ctx.path,
                nodeInfo: new $8b51f9b9b5b272ca$export$c3a21231378bfea9(this, index, [
                    ...ctx.path,
                    keyCtx.value
                ])
            };
            index = this.parseValue(index, valueCtx);
            index = this.skipIgnored(index);
            if (valueCtx && ctx.objectNodes) nodes.push(valueCtx.nodeInfo);
            else if (valueCtx && ctx.objectKey !== undefined) {
                ctx.objectNodes = [
                    valueCtx.nodeInfo
                ];
                return;
            }
            length++;
            if (this.data[index] === $8b51f9b9b5b272ca$var$COMMA) index++;
            else if (this.data[index] !== $8b51f9b9b5b272ca$var$BRACE_END) throw new Error(`parse object unexpected token ${$8b51f9b9b5b272ca$var$bufToString(this.data[index])} at ${index}. Expected , or }`);
        }
        if (ctx && ctx.nodeInfo) {
            ctx.nodeInfo.type = 'object';
            ctx.nodeInfo.length = length;
            ctx.nodeInfo.chars = index - start;
        }
        if (ctx && ctx.objectKeys) ctx.objectKeys = keys;
        if (ctx && ctx.objectNodes) ctx.objectNodes = nodes;
        function getKeyContext(keyIndex) {
            if (!ctx || ctx.start && keyIndex < ctx.start || ctx.limit && keyIndex >= ctx.start + ctx.limit) return null;
            if (ctx && (ctx.objectKeys || ctx.objectNodes || ctx.objectKey !== undefined)) return {
                path: ctx.path,
                value: null
            };
            return null;
        }
        return index;
    }
    parseArray(start, ctx) {
        let index = start + 1; // skip the start bracket
        let length = 0;
        while(index <= this.data.length){
            if (index === this.data.length) throw new Error(`parse array incomplete at end`);
            index = this.skipIgnored(index);
            if (this.data[index] === $8b51f9b9b5b272ca$var$BRACKET_END) {
                index++;
                break;
            }
            let valueCtx = null;
            if (isInRange(length) && ctx.arrayNodes) valueCtx = {
                path: ctx.path,
                nodeInfo: new $8b51f9b9b5b272ca$export$c3a21231378bfea9(this, index, [
                    ...ctx.path,
                    length.toString()
                ])
            };
            index = this.parseValue(index, valueCtx);
            if (valueCtx) ctx.arrayNodes.push(valueCtx.nodeInfo);
            index = this.skipIgnored(index);
            length++;
            if (this.data[index] === $8b51f9b9b5b272ca$var$COMMA) index++;
            else if (this.data[index] !== $8b51f9b9b5b272ca$var$BRACKET_END) throw new Error(`parse array unexpected token ${$8b51f9b9b5b272ca$var$bufToString(this.data[index])} at ${index}. Expected , or ]`);
        }
        if (ctx && ctx.nodeInfo) {
            ctx.nodeInfo.type = 'array';
            ctx.nodeInfo.length = length;
            ctx.nodeInfo.chars = index - start;
        }
        function isInRange(keyIndex) {
            return !(!ctx || ctx.start && keyIndex < ctx.start || ctx.limit && keyIndex >= ctx.start + ctx.limit);
        }
        return index;
    }
    parseString(start, ctx) {
        let index = start;
        const expect = this.data[index] === $8b51f9b9b5b272ca$var$DOUBLE_QUOTE ? $8b51f9b9b5b272ca$var$DOUBLE_QUOTE : $8b51f9b9b5b272ca$var$SINGLE_QUOTE;
        let esc = false, length = 0;
        for(index++; index <= this.data.length; index++){
            if (index === this.data.length) throw new Error(`parse string incomplete at end`);
            if (!esc && this.data[index] === expect) {
                index++;
                break;
            }
            if (this.data[index] === $8b51f9b9b5b272ca$var$BACK_SLASH) esc = !esc;
            else esc = false;
            if (!esc) length++;
        }
        if (ctx && ctx.nodeInfo) {
            ctx.nodeInfo.type = 'string';
            ctx.nodeInfo.length = length;
            ctx.nodeInfo.chars = index - start;
        }
        if (ctx && ctx.value !== undefined) ctx.value = JSON.parse($8b51f9b9b5b272ca$var$bufToString(this.data.subarray(start, index)));
        return index;
    }
    parseNumber(start, ctx) {
        let i = start;
        if (this.data[i] === $8b51f9b9b5b272ca$var$MINUS) i++;
        i = this.parseDigits(i);
        if (this.data[i] === $8b51f9b9b5b272ca$var$DOT) {
            i++;
            i = this.parseDigits(i);
        }
        if (this.data[i] === $8b51f9b9b5b272ca$var$CHAR_E_HIGH || this.data[i] === $8b51f9b9b5b272ca$var$CHAR_E_LOW) {
            i++;
            if (this.data[i] === $8b51f9b9b5b272ca$var$PLUS || this.data[i] === $8b51f9b9b5b272ca$var$MINUS) i++;
            i = this.parseDigits(i);
        }
        if (ctx && ctx.nodeInfo) {
            ctx.nodeInfo.type = 'number';
            ctx.nodeInfo.chars = i - start;
        }
        if (ctx && ctx.value !== undefined) ctx.value = JSON.parse($8b51f9b9b5b272ca$var$bufToString(this.data.subarray(start, i)));
        return i;
    }
    parseDigits(start) {
        while(this.data[start] >= $8b51f9b9b5b272ca$var$DIGIT_0 && this.data[start] <= $8b51f9b9b5b272ca$var$DIGIT_9)start++;
        return start;
    }
    parseToken(start, chars, ctx) {
        let index = start;
        for(let i = 0; i < chars.length; i++){
            if (this.data[index] !== chars[i]) throw new Error(`Unexpected token ${$8b51f9b9b5b272ca$var$bufToString(this.data[index])} at ${index}. Expected ${$8b51f9b9b5b272ca$var$bufToString(chars)}`);
            index++;
        }
        const token = $8b51f9b9b5b272ca$var$bufToString(this.data.subarray(start, index));
        if (ctx && ctx.nodeInfo) {
            if (token === 'null') ctx.nodeInfo.type = 'null';
            else ctx.nodeInfo.type = 'boolean';
            ctx.nodeInfo.chars = index - start;
        }
        if (ctx && ctx.value !== undefined) ctx.value = JSON.parse(token);
        return index;
    }
    parseNative(start, end) {
        return JSON.parse($8b51f9b9b5b272ca$var$bufToString(this.data.subarray(start, end)));
    }
    skipIgnored(start) {
        for(let i = start; i < this.data.length; i++){
            if ($8b51f9b9b5b272ca$var$IGNORED.indexOf(this.data[i]) !== -1) continue;
            return i;
        }
    }
}
function $8b51f9b9b5b272ca$var$bufToString(buf) {
    if (typeof buf === 'number') buf = [
        buf
    ];
    return String.fromCharCode.apply(null, buf);
}

});
parcelRegister("3NxB6", function(module, exports) {

$parcel$export(module.exports, "assertStartLimit", () => $63f21e5cf8cde4d8$export$dcfa27f977c5224c);
function $63f21e5cf8cde4d8$export$dcfa27f977c5224c(start, limit) {
    if (isNaN(start) || start < 0) throw new Error(`Invalid start ${start}`);
    if (limit && limit < 0) throw new Error(`Invalid limit ${limit}`);
}

});


parcelRegister("7vO2F", function(module, exports) {

$parcel$export(module.exports, "JsParser", () => $04e605f16dc82b7e$export$ff409fe831d40557);

var $3NxB6 = parcelRequire("3NxB6");
class $04e605f16dc82b7e$export$defd4a491b161b4d {
    constructor(ref, path){
        this.path = [];
        this.ref = ref;
        this.path = path;
        const jsType = typeof ref;
        if (jsType === 'undefined') this.type = 'undefined';
        if (jsType === 'symbol') this.type = 'symbol';
        if (jsType === 'function') this.type = 'function';
        if (jsType === 'object' && ref === null) this.type = 'null';
        else if (jsType === 'object' && Array.isArray(ref)) this.type = 'array';
        else this.type = jsType;
        if (this.type === 'object') this.length = Object.keys(ref).length;
        if (this.type === 'array' || this.type === 'string') this.length = ref.length;
    }
    /**
   * Returns the list of keys in case of an object for the defined range
   * @param {number} start
   * @param {number} limit
   */ getObjectKeys(start = 0, limit) {
        if (this.type !== 'object') throw new Error(`Unsupported method on non-object ${this.type}`);
        (0, $3NxB6.assertStartLimit)(start, limit);
        const keys = Object.keys(this.ref);
        if (limit) return keys.slice(start, start + limit);
        return keys.slice(start);
    }
    /**
   * Return the NodeInfo at the defined position.
   * Use the index from getObjectKeys
   * @param index
   */ getByIndex(index) {
        if (this.type === 'object') {
            const nodes = this.getObjectNodes(index, 1);
            if (nodes.length) return nodes[0];
        }
        if (this.type === 'array') {
            const nodes = this.getArrayNodes(index, 1);
            if (nodes.length) return nodes[0];
        }
        return undefined;
    }
    /**
   * Return the NodeInfo for the specified key
   * Use the index from getObjectKeys
   * @param key
   */ getByKey(key) {
        if (this.type === 'object' && this.ref.hasOwnProperty(key)) return new $04e605f16dc82b7e$export$defd4a491b161b4d(this.ref[key], [
            ...this.path,
            key
        ]);
        if (this.type === 'array') return this.getByIndex(parseInt(key));
        return undefined;
    }
    /**
   * Find the information for a given path
   * @param {string[]} path
   */ getByPath(path) {
        if (!path) return undefined;
        if (!path.length) return this;
        const p = path.slice();
        let key;
        let node = this;
        while((key = p.shift()) !== undefined && node)node = node.getByKey(key);
        return node;
    }
    /**
   * Returns a list with the NodeInfo objects for the defined range
   * @param {number} start
   * @param {number} limit
   */ getObjectNodes(start = 0, limit) {
        if (this.type !== 'object') throw new Error(`Unsupported method on non-object ${this.type}`);
        (0, $3NxB6.assertStartLimit)(start, limit);
        const nodes = {};
        return this.getObjectKeys(start, limit).map((key)=>new $04e605f16dc82b7e$export$defd4a491b161b4d(this.ref[key], [
                ...this.path,
                key
            ]));
    }
    /**
   * Returns a list of NodeInfo for the defined range
   * @param {number} start
   * @param {number} limit
   */ getArrayNodes(start = 0, limit) {
        if (this.type !== 'array') throw new Error(`Unsupported method on non-array ${this.type}`);
        (0, $3NxB6.assertStartLimit)(start, limit);
        const elements = limit ? this.ref.slice(start, start + limit) : this.ref.slice(start);
        return elements.map((ref, i)=>new $04e605f16dc82b7e$export$defd4a491b161b4d(ref, [
                ...this.path,
                String(start + i)
            ]));
    }
    /**
   * Get the natively parsed value
   */ getValue() {
        return this.ref;
    }
}
class $04e605f16dc82b7e$export$ff409fe831d40557 {
    constructor(data){
        this.data = data;
    }
    getRootNodeInfo() {
        if (this.data === undefined) return null;
        return new $04e605f16dc82b7e$export$defd4a491b161b4d(this.data, []);
    }
}

});


class $0089ee43e780e197$export$e4cd0dfd45d302cc {
    constructor(worker){
        this.worker = worker;
        this.requestIndex = 0;
        this.requestCallbacks = {};
    }
    initWorker() {
        return new Promise((resolve, reject)=>{
            this.worker.onmessage = (msg)=>{
                const data = msg.data;
                if (data._init === true) {
                    this.initialized = true;
                    resolve(true);
                    return;
                }
                if (data.resultId && this.requestCallbacks[data.resultId]) {
                    const callb = this.requestCallbacks[data.resultId];
                    delete this.requestCallbacks[data.resultId];
                    callb(data);
                }
            };
            this.worker.onerror = (e)=>{
                if (!this.initialized) reject(e);
                else console.error('Worker error', e);
            };
            this.worker.postMessage({
                _init: true
            });
        });
    }
    call(handler, ...args) {
        return this.callWorker(handler, undefined, ...args);
    }
    callWorker(handler, transfers, ...args) {
        return new Promise((resolve, reject)=>{
            const resultId = ++this.requestIndex;
            this.requestCallbacks[resultId] = (data)=>{
                if (data.error !== undefined) {
                    reject(data.error);
                    return;
                }
                resolve(data.result);
            };
            this.worker.postMessage({
                handler: handler,
                args: args,
                resultId: resultId
            }, transfers);
        });
    }
    destroy() {
        this.worker.terminate();
        this.worker = null;
        this.requestCallbacks = null;
    }
}
class $0089ee43e780e197$export$17ddad5eb3af88a1 {
    constructor(provider){
        this.provider = provider;
    }
    call(handler, ...args) {
        return this.callWorker(handler, undefined, ...args);
    }
    callWorker(handler, transfers, ...args) {
        return new Promise((resolve)=>{
            resolve(this.provider[handler].apply(this.provider, args));
        });
    }
    destroy() {
        this.provider = null;
    }
}



var $jl3no = parcelRequire("jl3no");
/* tslint:disable */ function $1f8cf106d30a9c70$export$7767ff246a267146() {
    const blob = new Blob([
        "!function(e,t,r,s,o,n,a,i){var h=\"undefined\"!=typeof globalThis?globalThis:\"undefined\"!=typeof self?self:\"undefined\"!=typeof window?window:\"undefined\"!=typeof global?global:{},l=\"function\"==typeof h[s]&&h[s],d=l.i||{},p=l.cache||{},u=\"undefined\"!=typeof module&&\"function\"==typeof module.require&&module.require.bind(module);function f(t,r){if(!p[t]){if(!e[t]){if(o[t])return o[t];var n=\"function\"==typeof h[s]&&h[s];if(!r&&n)return n(t,!0);if(l)return l(t,!0);if(u&&\"string\"==typeof t)return u(t);var a=Error(\"Cannot find module '\"+t+\"'\");throw a.code=\"MODULE_NOT_FOUND\",a}d.resolve=function(r){var s=e[t][1][r];return null!=s?s:r},d.cache={};var i=p[t]=new f.Module(t);e[t][0].call(i.exports,d,i,i.exports,h)}return p[t].exports;function d(e){var t=d.resolve(e);if(!1===t)return{};if(Array.isArray(t)){var r={__esModule:!0};return t.forEach(function(e){var t=e[0],s=e[1],o=e[2]||e[0],n=f(s);\"*\"===t?Object.keys(n).forEach(function(e){\"default\"===e||\"__esModule\"===e||Object.prototype.hasOwnProperty.call(r,e)||Object.defineProperty(r,e,{enumerable:!0,get:function(){return n[e]}})}):\"*\"===o?Object.defineProperty(r,t,{enumerable:!0,value:n}):Object.defineProperty(r,t,{enumerable:!0,get:function(){return\"default\"===o?n.__esModule?n.default:n:n[o]}})}),r}return f(t)}}f.isParcelRequire=!0,f.Module=function(e){this.id=e,this.bundle=f,this.require=u,this.exports={}},f.modules=e,f.cache=p,f.parent=l,f.distDir=void 0,f.publicUrl=void 0,f.devServer=void 0,f.i=d,f.register=function(t,r){e[t]=[function(e,t){t.exports=r},{}]},Object.defineProperty(f,\"root\",{get:function(){return h[s]}}),h[s]=f;for(var c=0;c<t.length;c++)f(t[c]);if(r){var y=f(r);\"object\"==typeof exports&&\"undefined\"!=typeof module?module.exports=y:\"function\"==typeof define&&define.amd&&define(function(){return y})}}({kGz5N:[function(e,t,r,s){var o=e(\"../helpers/worker-provider\"),n=e(\"../big-json-viewer-service\");(0,o.initProvider)(new(0,n.BigJsonViewerService))},{\"../helpers/worker-provider\":\"vpIKR\",\"../big-json-viewer-service\":\"lsYGb\"}],vpIKR:[function(e,t,r,s){var o=e(\"@parcel/transformer-js/src/esmodule-helpers.js\");function n(e,t=self){t.onmessage=function(r){let s=r.data;if(s._init)return void t.postMessage({_init:!0});if(s.handler&&e[s.handler])try{let r=e[s.handler].apply(e,s.args);s.resultId&&t.postMessage({resultId:s.resultId,result:r})}catch(e){s.resultId&&t.postMessage({resultId:s.resultId,error:e.toString()})}}}o.defineInteropFlag(r),o.export(r,\"initProvider\",()=>n)},{\"@parcel/transformer-js/src/esmodule-helpers.js\":\"kdXvs\"}],kdXvs:[function(e,t,r,s){r.interopDefault=function(e){return e&&e.__esModule?e:{default:e}},r.defineInteropFlag=function(e){Object.defineProperty(e,\"__esModule\",{value:!0})},r.exportAll=function(e,t){return Object.keys(e).forEach(function(r){\"default\"===r||\"__esModule\"===r||Object.prototype.hasOwnProperty.call(t,r)||Object.defineProperty(t,r,{enumerable:!0,get:function(){return e[r]}})}),t},r.export=function(e,t,r){Object.defineProperty(e,t,{enumerable:!0,get:r})}},{}],lsYGb:[function(e,t,r,s){var o=e(\"@parcel/transformer-js/src/esmodule-helpers.js\");o.defineInteropFlag(r),o.export(r,\"BigJsonViewerService\",()=>h);var n=e(\"./parser/json-node-search\"),a=e(\"./parser/buffer-json-parser\"),i=e(\"./parser/js-parser\");class h{initWithData(e){return this.rootNode=new(0,a.BufferJsonParser)(e).getRootNodeInfo(),this.getRenderInfo(this.rootNode)}initWithJs(e){return this.rootNode=new(0,i.JsParser)(e).getRootNodeInfo(),this.getRenderInfo(this.rootNode)}getNodes(e,t,r){let s=this.rootNode.getByPath(e);return s&&\"object\"===s.type?s.getObjectNodes(t,r).map(e=>this.getRenderInfo(e)):s&&\"array\"===s.type?s.getArrayNodes(t,r).map(e=>this.getRenderInfo(e)):null}getKeyIndex(e,t){let r=this.rootNode.getByPath(e);return r?r.getObjectKeys().indexOf(t):-1}search(e,t){return(0,n.searchJsonNodes)(this.rootNode,e,t)}getRenderInfo(e){let t={type:e.type,length:e.length,path:e.path,openable:this.isOpenableNode(e)};return t.openable||(t.value=e.getValue()),t}isOpenableNode(e){return(\"array\"===e.type||\"object\"===e.type)&&!!e.length}}},{\"./parser/json-node-search\":\"bjnFk\",\"./parser/buffer-json-parser\":\"aPMcZ\",\"./parser/js-parser\":\"6NMJx\",\"@parcel/transformer-js/src/esmodule-helpers.js\":\"kdXvs\"}],bjnFk:[function(e,t,r,s){var o=e(\"@parcel/transformer-js/src/esmodule-helpers.js\");function n(e,t,r){(e=a(e)).lastIndex=0;let s=null;for(;null!==(s=e.exec(t));)r(s.index,s[0].length);e.lastIndex=0}function a(e){if(!e.global){let t=\"g\"+(e.ignoreCase?\"i\":\"\")+(e.multiline?\"m\":\"\");return new RegExp(e.source,t)}return e}o.defineInteropFlag(r),o.export(r,\"searchJsonNodes\",()=>function e(t,r,s=\"all\"){r=a(r);let o=[];return t.path.length&&(\"all\"===s||\"keys\"===s)&&n(r,t.path[t.path.length-1],(e,r)=>{o.push({path:t.path,key:e,length:r})}),\"object\"===t.type?t.getObjectNodes().forEach(t=>{o.push(...e(t,r,s))}):\"array\"===t.type?t.getArrayNodes().forEach(t=>{o.push(...e(t,r,s))}):(\"all\"===s||\"values\"===s)&&n(r,String(t.getValue()),(e,r)=>{o.push({path:t.path,value:e,length:r})}),o}),o.export(r,\"forEachMatchFromString\",()=>n)},{\"@parcel/transformer-js/src/esmodule-helpers.js\":\"kdXvs\"}],aPMcZ:[function(e,t,r,s){var o=e(\"@parcel/transformer-js/src/esmodule-helpers.js\");o.defineInteropFlag(r),o.export(r,\"BufferJsonNodeInfo\",()=>d),o.export(r,\"BufferJsonParser\",()=>p);var n=e(\"../helpers/utils\");let a=[32,9,10,13],i=\"null\".split(\"\").map(e=>e.charCodeAt(0)),h=\"true\".split(\"\").map(e=>e.charCodeAt(0)),l=\"false\".split(\"\").map(e=>e.charCodeAt(0));class d{constructor(e,t,r){this.path=[],this.parser=e,this.index=t,this.path=r}getObjectKeys(e=0,t){if(\"object\"!==this.type)throw Error(`Unsupported method on non-object ${this.type}`);(0,n.assertStartLimit)(e,t);let r={path:this.path,objectKeys:[],start:e,limit:t};return this.parser.parseObject(this.index,r),r.objectKeys}getByIndex(e){if(\"object\"===this.type){let t=this.getObjectNodes(e,1);if(t.length)return t[0]}if(\"array\"===this.type){let t=this.getArrayNodes(e,1);if(t.length)return t[0]}}getByKey(e){if(\"object\"===this.type){let t={path:this.path,objectKey:e};return this.parser.parseObject(this.index,t),t.objectNodes?t.objectNodes[0]:void 0}if(\"array\"===this.type)return this.getByIndex(parseInt(e))}getByPath(e){let t;if(!e)return;if(!e.length)return this;let r=e.slice(),s=this;for(;void 0!==(t=r.shift())&&s;)s=s.getByKey(t);return s}getObjectNodes(e=0,t){if(\"object\"!==this.type)throw Error(`Unsupported method on non-object ${this.type}`);(0,n.assertStartLimit)(e,t);let r={path:this.path,objectNodes:[],start:e,limit:t};return this.parser.parseObject(this.index,r),r.objectNodes}getArrayNodes(e=0,t){if(\"array\"!==this.type)throw Error(`Unsupported method on non-array ${this.type}`);(0,n.assertStartLimit)(e,t);let r={path:this.path,arrayNodes:[],start:e,limit:t};return this.parser.parseArray(this.index,r),r.arrayNodes}getValue(){return this.parser.parseNative(this.index,this.index+this.chars)}}class p{constructor(e){if(e instanceof ArrayBuffer)this.data=new Uint16Array(e);else if(\"string\"==typeof e&&\"undefined\"!=typeof TextEncoder)this.data=new TextEncoder().encode(e);else if(\"string\"==typeof e){this.data=new Uint16Array(new ArrayBuffer(2*e.length));for(let t=0;t<e.length;t++)this.data[t]=e.charCodeAt(t)}}getRootNodeInfo(){let e=this.skipIgnored(0),t={path:[],nodeInfo:new d(this,e,[])},r=this.parseValue(e,t,!1);return e===r?null:t.nodeInfo}parseValue(e,t,r=!0){var s,o;let n=this.data[e];if(34===(s=n)||39===s)return this.parseString(e,t);if(45===(o=n)||o>=48&&o<=57)return this.parseNumber(e,t);if(123===n)return this.parseObject(e,t);if(91===n)return this.parseArray(e,t);if(n===h[0])return this.parseToken(e,h,t);if(n===l[0])return this.parseToken(e,l,t);if(n===i[0])return this.parseToken(e,i,t);if(r)throw Error(`parse value unknown token ${u(n)} at ${e}`)}parseObject(e,t){let r=e+1,s=0,o=[],n=[];for(;r<=this.data.length;){var a;if(r===this.data.length)throw Error(\"parse object incomplete at end\");if(r=this.skipIgnored(r),125===this.data[r]){r++;break}let e=(a=s,!t||t.start&&a<t.start||t.limit&&a>=t.start+t.limit?null:t&&(t.objectKeys||t.objectNodes||void 0!==t.objectKey)?{path:t.path,value:null}:null);if(r=this.parseString(r,e),e&&t&&t.objectKeys&&o.push(e.value),r=this.skipIgnored(r),58!==this.data[r])throw Error(`parse object unexpected token ${u(this.data[r])} at ${r}. Expected :`);r++,r=this.skipIgnored(r);let i=null;if(e&&t&&(t.objectNodes||e.value===t.objectKey)&&(i={path:t.path,nodeInfo:new d(this,r,[...t.path,e.value])}),r=this.parseValue(r,i),r=this.skipIgnored(r),i&&t.objectNodes)n.push(i.nodeInfo);else if(i&&void 0!==t.objectKey){t.objectNodes=[i.nodeInfo];return}if(s++,44===this.data[r])r++;else if(125!==this.data[r])throw Error(`parse object unexpected token ${u(this.data[r])} at ${r}. Expected , or }`)}return t&&t.nodeInfo&&(t.nodeInfo.type=\"object\",t.nodeInfo.length=s,t.nodeInfo.chars=r-e),t&&t.objectKeys&&(t.objectKeys=o),t&&t.objectNodes&&(t.objectNodes=n),r}parseArray(e,t){let r=e+1,s=0;for(;r<=this.data.length;){var o;if(r===this.data.length)throw Error(\"parse array incomplete at end\");if(r=this.skipIgnored(r),93===this.data[r]){r++;break}let e=null;if(o=s,!(!t||t.start&&o<t.start||t.limit&&o>=t.start+t.limit)&&t.arrayNodes&&(e={path:t.path,nodeInfo:new d(this,r,[...t.path,s.toString()])}),r=this.parseValue(r,e),e&&t.arrayNodes.push(e.nodeInfo),r=this.skipIgnored(r),s++,44===this.data[r])r++;else if(93!==this.data[r])throw Error(`parse array unexpected token ${u(this.data[r])} at ${r}. Expected , or ]`)}return t&&t.nodeInfo&&(t.nodeInfo.type=\"array\",t.nodeInfo.length=s,t.nodeInfo.chars=r-e),r}parseString(e,t){let r=e,s=34===this.data[r]?34:39,o=!1,n=0;for(r++;r<=this.data.length;r++){if(r===this.data.length)throw Error(\"parse string incomplete at end\");if(!o&&this.data[r]===s){r++;break}!(o=92===this.data[r]&&!o)&&n++}return t&&t.nodeInfo&&(t.nodeInfo.type=\"string\",t.nodeInfo.length=n,t.nodeInfo.chars=r-e),t&&void 0!==t.value&&(t.value=JSON.parse(u(this.data.subarray(e,r)))),r}parseNumber(e,t){let r=e;return 45===this.data[r]&&r++,r=this.parseDigits(r),46===this.data[r]&&(r++,r=this.parseDigits(r)),(69===this.data[r]||101===this.data[r])&&(r++,(43===this.data[r]||45===this.data[r])&&r++,r=this.parseDigits(r)),t&&t.nodeInfo&&(t.nodeInfo.type=\"number\",t.nodeInfo.chars=r-e),t&&void 0!==t.value&&(t.value=JSON.parse(u(this.data.subarray(e,r)))),r}parseDigits(e){for(;this.data[e]>=48&&this.data[e]<=57;)e++;return e}parseToken(e,t,r){let s=e;for(let e=0;e<t.length;e++){if(this.data[s]!==t[e])throw Error(`Unexpected token ${u(this.data[s])} at ${s}. Expected ${u(t)}`);s++}let o=u(this.data.subarray(e,s));return r&&r.nodeInfo&&(\"null\"===o?r.nodeInfo.type=\"null\":r.nodeInfo.type=\"boolean\",r.nodeInfo.chars=s-e),r&&void 0!==r.value&&(r.value=JSON.parse(o)),s}parseNative(e,t){return JSON.parse(u(this.data.subarray(e,t)))}skipIgnored(e){for(let t=e;t<this.data.length;t++)if(-1===a.indexOf(this.data[t]))return t}}function u(e){return\"number\"==typeof e&&(e=[e]),String.fromCharCode.apply(null,e)}},{\"../helpers/utils\":\"501Ss\",\"@parcel/transformer-js/src/esmodule-helpers.js\":\"kdXvs\"}],\"501Ss\":[function(e,t,r,s){var o=e(\"@parcel/transformer-js/src/esmodule-helpers.js\");function n(e,t){if(isNaN(e)||e<0)throw Error(`Invalid start ${e}`);if(t&&t<0)throw Error(`Invalid limit ${t}`)}o.defineInteropFlag(r),o.export(r,\"assertStartLimit\",()=>n)},{\"@parcel/transformer-js/src/esmodule-helpers.js\":\"kdXvs\"}],\"6NMJx\":[function(e,t,r,s){var o=e(\"@parcel/transformer-js/src/esmodule-helpers.js\");o.defineInteropFlag(r),o.export(r,\"JsJsonNodeInfo\",()=>a),o.export(r,\"JsParser\",()=>i);var n=e(\"../helpers/utils\");class a{constructor(e,t){this.path=[],this.ref=e,this.path=t;const r=typeof e;\"undefined\"===r&&(this.type=\"undefined\"),\"symbol\"===r&&(this.type=\"symbol\"),\"function\"===r&&(this.type=\"function\"),\"object\"===r&&null===e?this.type=\"null\":\"object\"===r&&Array.isArray(e)?this.type=\"array\":this.type=r,\"object\"===this.type&&(this.length=Object.keys(e).length),(\"array\"===this.type||\"string\"===this.type)&&(this.length=e.length)}getObjectKeys(e=0,t){if(\"object\"!==this.type)throw Error(`Unsupported method on non-object ${this.type}`);(0,n.assertStartLimit)(e,t);let r=Object.keys(this.ref);return t?r.slice(e,e+t):r.slice(e)}getByIndex(e){if(\"object\"===this.type){let t=this.getObjectNodes(e,1);if(t.length)return t[0]}if(\"array\"===this.type){let t=this.getArrayNodes(e,1);if(t.length)return t[0]}}getByKey(e){return\"object\"===this.type&&this.ref.hasOwnProperty(e)?new a(this.ref[e],[...this.path,e]):\"array\"===this.type?this.getByIndex(parseInt(e)):void 0}getByPath(e){let t;if(!e)return;if(!e.length)return this;let r=e.slice(),s=this;for(;void 0!==(t=r.shift())&&s;)s=s.getByKey(t);return s}getObjectNodes(e=0,t){if(\"object\"!==this.type)throw Error(`Unsupported method on non-object ${this.type}`);return(0,n.assertStartLimit)(e,t),this.getObjectKeys(e,t).map(e=>new a(this.ref[e],[...this.path,e]))}getArrayNodes(e=0,t){if(\"array\"!==this.type)throw Error(`Unsupported method on non-array ${this.type}`);return(0,n.assertStartLimit)(e,t),(t?this.ref.slice(e,e+t):this.ref.slice(e)).map((t,r)=>new a(t,[...this.path,String(e+r)]))}getValue(){return this.ref}}class i{constructor(e){this.data=e}getRootNodeInfo(){return void 0===this.data?null:new a(this.data,[])}}},{\"../helpers/utils\":\"501Ss\",\"@parcel/transformer-js/src/esmodule-helpers.js\":\"kdXvs\"}]},[\"kGz5N\"],\"kGz5N\",\"parcelRequire13a7\",{});\n//# sourceMappingURL=big-json-viewer.worker.js.map\n"
    ], {
        type: 'text/javascript'
    });
    const workerUrl = URL.createObjectURL(blob);
    return new Worker(workerUrl);
}



class $0096928a09a25e8f$export$6efa9165c4ad4d70 {
    /**
   * Initialized the viewer with JSON encoded data
   */ static async fromData(data, options) {
        const viewer = new $0096928a09a25e8f$export$6efa9165c4ad4d70(options);
        await viewer.setData(data);
        return viewer;
    }
    /**
   * Initializes the viewer with a JavaScript object
   */ static async fromObject(data, options) {
        const viewer = new $0096928a09a25e8f$export$6efa9165c4ad4d70(options);
        await viewer.setObject(data);
        return viewer;
    }
    constructor(options){
        this.options = {
            objectNodesLimit: 50,
            arrayNodesLimit: 50,
            labelAsPath: false,
            linkLabelCopyPath: 'Copy path',
            linkLabelExpandAll: 'Expand all',
            workerPath: null,
            collapseSameValue: 5,
            showExtendedJson: false,
            maxStringPreviewLength: 250
        };
        this.currentArea = 'all';
        this.currentMark = null;
        if (options) Object.assign(this.options, options);
    }
    async getWorkerClient() {
        if (!this.workerClient) try {
            const worker = this.options.workerPath ? new Worker(this.options.workerPath) : (0, $1f8cf106d30a9c70$export$7767ff246a267146)();
            const client = new (0, $0089ee43e780e197$export$e4cd0dfd45d302cc)(worker);
            await client.initWorker();
            this.workerClient = client;
        } catch (e) {
            console.warn('Could not instantiate Worker ' + this.options.workerPath + ', using mock', e);
            const serviceModule = (parcelRequire("dpnMS"));
            const service = new serviceModule.BigJsonViewerService();
            this.workerClient = new (0, $0089ee43e780e197$export$17ddad5eb3af88a1)(service);
        }
        return this.workerClient;
    }
    async setData(data) {
        const client = await this.getWorkerClient();
        this.rootNode = await client.call('initWithData', data);
        return this.rootNode;
    }
    async setObject(data) {
        const client = await this.getWorkerClient();
        this.rootNode = await client.call('initWithJs', data);
        return this.rootNode;
    }
    async getChildNodes(path, start, limit, withExtendedJson = true) {
        const client = await this.getWorkerClient();
        const nodes = await client.call('getNodes', path, start, limit);
        if (withExtendedJson && this.options.showExtendedJson) return Promise.all(nodes.map((n)=>this.transformExtendedJsonNode(n)));
        return nodes;
    }
    async transformExtendedJsonNode(node) {
        if (node.type !== 'object' || node.length !== 1) return node;
        const childNode = (await this.getChildNodes(node.path, 0, node.length, false))[0];
        const createOfTypeNode = (type, value, length)=>{
            return {
                type: type,
                path: node.path,
                value: value,
                length: length,
                openable: false
            };
        };
        const stringTransformers = {
            $oid: (node)=>createOfTypeNode('ObjectId', node.value),
            $date: (node)=>createOfTypeNode('Date', node.value),
            $numberDecimal: (node)=>createOfTypeNode('Decimal128', parseFloat(node.value)),
            $numberDouble: (node)=>createOfTypeNode('Double', parseFloat(node.value)),
            $numberLong: (node)=>createOfTypeNode('Int64', parseFloat(node.value)),
            $numberInt: (node)=>createOfTypeNode('Int32', parseFloat(node.value)),
            $maxKey: (node)=>createOfTypeNode('MaxKey', parseFloat(node.value)),
            $minKey: (node)=>createOfTypeNode('MinKey', parseFloat(node.value)),
            $uuid: (node)=>createOfTypeNode('UUID', node.value)
        };
        const subObjectTransformers = {
            $binary: (data)=>createOfTypeNode('Binary', data, this.base64ByteLength(data.base64)),
            $date: (data)=>createOfTypeNode('Date', new Date(parseFloat(data.$numberLong)).toISOString()),
            $regularExpression: (data)=>createOfTypeNode('RegExp', `/${data.pattern}/${data.options}`),
            $timestamp: (data)=>createOfTypeNode('Timestamp', data)
        };
        try {
            const name = childNode.path[childNode.path.length - 1];
            if (subObjectTransformers[name] && childNode.type === 'object') {
                const data = await this.nodeToValue(childNode);
                return subObjectTransformers[name](data);
            } else if (stringTransformers[name] && (childNode.type === 'string' || childNode.type === 'number')) return stringTransformers[name](childNode);
        } catch (e) {
            console.warn('Could not transform extended JSON node ' + node.path, e);
        }
        return node;
    }
    base64ByteLength(base64) {
        // Count padding characters
        const padding = (base64.match(/=+$/) || [
            ''
        ])[0].length;
        return Math.floor(base64.length * 3 / 4) - padding;
    }
    async nodeToValue(node) {
        if (node.type === 'object') {
            const obj = {};
            const childNodes = await this.getChildNodes(node.path, 0, node.length);
            for(let i = 0; i < childNodes.length; i++){
                const childNode = childNodes[i];
                const key = childNode.path[childNode.path.length - 1];
                obj[key] = await this.nodeToValue(childNode);
            }
            return obj;
        } else if (node.type === 'array') {
            const arr = [];
            const childNodes = await this.getChildNodes(node.path, 0, node.length);
            for(let i = 0; i < childNodes.length; i++){
                const childNode = childNodes[i];
                arr.push(await this.nodeToValue(childNode));
            }
            return arr;
        } else return node.value;
    }
    async getSearchMatches(pattern, searchArea) {
        const client = await this.getWorkerClient();
        return await client.call('search', pattern, searchArea);
    }
    async getKeyIndex(path, key) {
        const client = await this.getWorkerClient();
        return await client.call('getKeyIndex', path, key);
    }
    /**
   * Destroys the viewer and frees resources like the worker
   */ destroy() {
        if (this.workerClient) {
            this.workerClient.destroy();
            this.workerClient = null;
        }
        this.rootElement = null;
        this.currentPattern = null;
    }
    getRootElement() {
        if (this.rootElement) return this.rootElement;
        if (this.rootNode) {
            const nodeElement = this.getNodeElement(this.rootNode);
            nodeElement.classList.add('json-node-root');
            this.rootElement = nodeElement;
            return nodeElement;
        }
        return null;
    }
    getNodeElement(node) {
        const element = document.createElement('div');
        element.classList.add('json-node');
        element.jsonNode = node;
        const header = this.getNodeHeader(node);
        element.headerElement = element.appendChild(header);
        this.attachInteractivity(element, node);
        return element;
    }
    attachInteractivity(nodeElement, node) {
        nodeElement.isNodeOpen = ()=>{
            if (this.isOpenableNode(node)) return nodeElement.headerElement.classList.contains('json-node-open');
            return false;
        };
        nodeElement.openNode = async (dispatchEvent = false)=>{
            if (this.isOpenableNode(node)) return await this.openNode(nodeElement, dispatchEvent);
            return false;
        };
        nodeElement.closeNode = async (dispatchEvent = false)=>{
            if (this.isOpenableNode(node)) return this.closeNode(nodeElement, dispatchEvent);
            return false;
        };
        nodeElement.toggleNode = async (dispatchEvent = false)=>{
            if (nodeElement.isNodeOpen()) return await nodeElement.closeNode(dispatchEvent);
            else return await nodeElement.openNode(dispatchEvent);
        };
        nodeElement.openPath = async (path)=>{
            if (this.isOpenableNode(node)) return await this.openPath(nodeElement, path, true);
            return null;
        };
        nodeElement.openAll = async (maxDepth = Infinity, paginated = 'first')=>{
            if (this.isOpenableNode(node)) return await this.openAll(nodeElement, maxDepth, paginated);
            return 0;
        };
        nodeElement.getOpenPaths = (withStubs = true)=>{
            if (this.isOpenableNode(node)) return this.getOpenPaths(nodeElement, withStubs);
            return [];
        };
    }
    attachClickToggleListener(anchor) {
        anchor.addEventListener('click', (e)=>{
            e.preventDefault();
            const nodeElement = this.findNodeElement(anchor);
            if (nodeElement) nodeElement.toggleNode(true);
        });
    }
    isOpenableNode(node) {
        return (node.type === 'array' || node.type === 'object') && node.length;
    }
    closeNode(nodeElement, dispatchEvent = false) {
        if (!nodeElement.isNodeOpen()) return false;
        if (nodeElement.childrenElement) {
            nodeElement.headerElement.classList.remove('json-node-open');
            nodeElement.removeChild(nodeElement.childrenElement);
            nodeElement.childrenElement = null;
            if (dispatchEvent) this.dispatchNodeEvent('closeNode', nodeElement);
            return true;
        }
        return false;
    }
    refreshHeaders(nodeElement) {
        const header = this.getNodeHeader(nodeElement.jsonNode);
        if (nodeElement.isNodeOpen()) header.classList.add('json-node-open');
        nodeElement.headerElement.parentElement.replaceChild(header, nodeElement.headerElement);
        nodeElement.headerElement = header;
        if (nodeElement.childrenElement) this.getVisibleChildren(nodeElement.childrenElement.children).forEach((element)=>this.refreshHeaders(element));
    }
    generateTruncatedText(text) {
        const fragment = document.createDocumentFragment();
        if (text.length < this.options.maxStringPreviewLength) {
            fragment.appendChild(document.createTextNode(text));
            return fragment;
        }
        const truncTextNode = document.createElement('span');
        const renderTruncated = ()=>{
            truncTextNode.classList.add('json-node-value-truncated');
            truncTextNode.classList.remove('json-node-value-expanded');
            truncTextNode.innerHTML = '';
            truncTextNode.appendChild(document.createTextNode(text.slice(0, this.options.maxStringPreviewLength)));
        };
        const renderExpanded = ()=>{
            truncTextNode.classList.remove('json-node-value-truncated');
            truncTextNode.classList.add('json-node-value-expanded');
            truncTextNode.innerHTML = '';
            truncTextNode.appendChild(document.createTextNode(text));
        };
        renderTruncated();
        fragment.appendChild(truncTextNode);
        const link = document.createElement('a');
        link.classList.add('json-node-value-expand-link');
        link.href = 'javascript:';
        link.innerText = '...';
        link.addEventListener('click', (e)=>{
            e.preventDefault();
            if (truncTextNode.classList.contains('json-node-value-truncated')) {
                renderExpanded();
                link.innerText = '<<';
            } else {
                renderTruncated();
                link.innerText = '...';
            }
        });
        fragment.appendChild(link);
        return fragment;
    }
    getHighlightedText(text, pattern) {
        const fragment = document.createDocumentFragment();
        if (!pattern) return this.generateTruncatedText(text);
        let lastIndex = 0;
        (0, $jl3no.forEachMatchFromString)(pattern, text, (index, length)=>{
            if (lastIndex < index) fragment.appendChild(document.createTextNode(text.substring(lastIndex, index)));
            const mark = document.createElement('mark');
            mark.appendChild(document.createTextNode(text.substr(index, length)));
            fragment.appendChild(mark);
            lastIndex = index + length;
        });
        if (lastIndex !== text.length) fragment.appendChild(document.createTextNode(text.substring(lastIndex, text.length)));
        return fragment;
    }
    /**
   * Opens the tree nodes based on a pattern
   * openLimit is 1 by default, you can provide Infinity for all
   * searchArea is 'all' by default
   */ async openBySearch(pattern, openLimit = 1, searchArea = 'all') {
        const nodeElement = this.rootElement;
        this.currentPattern = pattern;
        this.currentArea = searchArea;
        if (!pattern) {
            this.closeNode(nodeElement, true);
            return null;
        }
        this.refreshHeaders(nodeElement);
        const viewer = this;
        const matches = await this.getSearchMatches(pattern, searchArea);
        const cursor = {
            matches: matches,
            index: 0,
            async navigateTo (index) {
                this.index = index;
                const match = this.matches[index];
                if (!match) {
                    console.warn('searchIndex does not exist on ' + this.matches.length, index);
                    return;
                }
                const openedElement = await viewer.openSearchMatch(nodeElement, match);
                if (openedElement) {
                    if (openedElement.scrollIntoView) openedElement.scrollIntoView({
                        block: 'center'
                    });
                    if (viewer.currentMark) viewer.currentMark.classList.remove('highlight-active');
                    viewer.currentMark = viewer.findMarkForMatch(openedElement, match);
                    if (viewer.currentMark) viewer.currentMark.classList.add('highlight-active');
                    return true;
                }
                return false;
            },
            next () {
                return this.navigateTo(this.index + 1 >= this.matches.length ? 0 : this.index + 1);
            },
            previous () {
                return this.navigateTo(this.index - 1 < 0 ? this.matches.length : this.index - 1);
            }
        };
        const length = Math.min(matches.length, openLimit);
        for(let i = 0; i < length && i < openLimit; i++)await this.openSearchMatch(nodeElement, matches[i]);
        this.dispatchNodeEvent('openedNodes', nodeElement);
        if (matches.length) await cursor.navigateTo(0);
        return cursor;
    }
    findMarkForMatch(nodeElement, match) {
        let children = null, expectIndex = 0;
        if (match.key !== undefined) {
            const label = nodeElement.headerElement.querySelector('.json-node-label');
            if (label) {
                children = label.childNodes;
                expectIndex = match.key;
            }
        }
        if (match.value !== undefined) {
            const value = nodeElement.headerElement.querySelector('.json-node-value');
            if (value) {
                children = value.childNodes;
                expectIndex = match.value;
            }
        }
        if (children) {
            let index = nodeElement.jsonNode.type === 'string' ? -1 : 0;
            for(let i = 0; i < children.length; i++){
                const cn = children[i];
                if (cn.nodeType === Node.TEXT_NODE) index += cn.textContent.length;
                if (cn.nodeType === Node.ELEMENT_NODE && cn.tagName === 'MARK' && expectIndex === index) return cn;
            }
        }
        return null;
    }
    async openSearchMatch(nodeElement, match) {
        if (match.key !== undefined && match.path.length) {
            if (match.path.length) {
                const matchNodeElementParent = await this.openPath(nodeElement, match.path.slice(0, -1)); // open the parent
                if (matchNodeElementParent) return await this.openKey(matchNodeElementParent, match.path[match.path.length - 1]); // ensure the key is visible
            }
        } else if (match.value !== undefined) return await this.openPath(nodeElement, match.path);
        return null;
    }
    getOpenPaths(nodeElement, withSubs) {
        const result = [];
        if (!nodeElement.isNodeOpen()) return result;
        const children = nodeElement.childrenElement.children;
        const nodeElements = this.getVisibleChildren(children);
        for(let i = 0; i < nodeElements.length; i++){
            const element = nodeElements[i];
            if (element.isNodeOpen()) result.push(...this.getOpenPaths(element, withSubs));
        }
        const limit = this.getPaginationLimit(nodeElement.jsonNode);
        // find open stubs
        if (!result.length && limit) for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child.isNodeOpen() && child.childrenElement && child.childrenElement.children.length) {
                const first = child.childrenElement.children[0];
                if (first.jsonNode) result.push(first.jsonNode.path);
            }
        }
        if (!result.length) result.push(nodeElement.jsonNode.path);
        return result;
    }
    async openNode(nodeElement, dispatchEvent = false) {
        if (nodeElement.isNodeOpen()) return false;
        nodeElement.headerElement.classList.add('json-node-open');
        const children = await this.getPaginatedNodeChildren(nodeElement);
        nodeElement.childrenElement = nodeElement.appendChild(children);
        if (dispatchEvent) this.dispatchNodeEvent('openNode', nodeElement);
        return true;
    }
    dispatchNodeEvent(type, nodeElement) {
        let event;
        if (document.createEvent) {
            event = document.createEvent('Event');
            event.initEvent(type, true, false);
        } else event = new Event(type, {
            bubbles: true,
            cancelable: false
        });
        nodeElement.dispatchEvent(event);
    }
    async openKey(nodeElement, key) {
        const node = nodeElement.jsonNode;
        let children = null;
        let index = -1;
        if (node.type === 'object') {
            index = await this.getKeyIndex(node.path, key);
            if (index === -1) return null;
            await nodeElement.openNode();
            // find correct stub in pagination
            if (node.length > this.options.objectNodesLimit) {
                const stubIndex = Math.floor(index / this.options.objectNodesLimit);
                const stub = nodeElement.childrenElement.children[stubIndex];
                if (stub) {
                    await stub.openNode();
                    index -= stubIndex * this.options.objectNodesLimit;
                    children = stub.childrenElement.children;
                }
            } else children = nodeElement.childrenElement.children;
        }
        if (node.type === 'array') {
            index = parseInt(key);
            if (isNaN(index) || index >= node.length || index < 0) return null;
            await nodeElement.openNode();
            // find correct stub in pagination
            if (node.length > this.options.arrayNodesLimit) {
                const stubIndex = Math.floor(index / this.options.arrayNodesLimit);
                const stub = nodeElement.childrenElement.children[stubIndex];
                if (stub) {
                    await stub.openNode();
                    index -= stubIndex * this.options.arrayNodesLimit;
                    children = stub.childrenElement.children;
                }
            } else children = nodeElement.childrenElement.children;
        }
        if (children && index >= 0 && index < children.length) {
            const childNodeElement = children[index];
            if (!childNodeElement.jsonNode) return null;
            return childNodeElement;
        }
        return null;
    }
    async openPath(nodeElement, path, dispatchEvent = false) {
        if (!path.length) {
            await this.openNode(nodeElement, dispatchEvent);
            return nodeElement;
        }
        let element = nodeElement;
        for(let i = 0; i < path.length; i++){
            if (!element) return null;
            element = await this.openKey(element, path[i]);
            if (element) await element.openNode();
        }
        if (dispatchEvent) this.dispatchNodeEvent('openedNodes', nodeElement);
        return element;
    }
    async openAll(nodeElement, maxDepth, paginated, dispatchEvent = false) {
        await nodeElement.openNode();
        let opened = 1;
        if (maxDepth <= 1 || !nodeElement.childrenElement) return opened;
        const newMaxDepth = maxDepth === Infinity ? Infinity : maxDepth - 1;
        opened += await this.openAllChildren(nodeElement.childrenElement.children, newMaxDepth, paginated);
        if (dispatchEvent) this.dispatchNodeEvent('openedNodes', nodeElement);
        return opened;
    }
    async openAllChildren(children, maxDepth, paginated) {
        let opened = 0;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child.jsonNode) // is a node
            opened += await child.openAll(maxDepth, paginated);
            else if (child.openNode) {
                // is a stub
                if (paginated === 'none') return opened;
                await child.openNode();
                if (child.childrenElement) opened += await this.openAllChildren(child.childrenElement.children, maxDepth, paginated);
                if (paginated === 'first') return opened;
            }
        }
        return opened;
    }
    /**
   * Returns the pagination limit, if the node should have
   */ getPaginationLimit(node) {
        if (node.type === 'array' && node.length > this.options.arrayNodesLimit) return this.options.arrayNodesLimit;
        if (node.type === 'object' && node.length > this.options.objectNodesLimit) return this.options.objectNodesLimit;
        return 0;
    }
    getVisibleChildren(children) {
        const result = [];
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child.jsonNode) // is a node
            result.push(child);
            else if (child.openNode && child.isNodeOpen() && child.childrenElement) // is a stub
            result.push(...this.getVisibleChildren(child.childrenElement.children));
        }
        return result;
    }
    async getPaginatedNodeChildren(nodeElement) {
        const node = nodeElement.jsonNode;
        const element = document.createElement('div');
        element.classList.add('json-node-children');
        const limit = this.getPaginationLimit(node);
        if (limit) for(let start = 0; start < node.length; start += limit)element.appendChild(this.getPaginationStub(node, start, limit));
        else {
            const nodes = await this.getChildNodes(node.path, 0, limit);
            this.addChildNodes(nodes, element, node.type === 'array' ? this.options.collapseSameValue : Infinity);
        }
        return element;
    }
    getPaginationStub(node, start, limit) {
        const stubElement = document.createElement('div');
        stubElement.classList.add('json-node-stub');
        const anchor = document.createElement('a');
        anchor.href = 'javascript:';
        anchor.classList.add('json-node-stub-toggler');
        stubElement.headerElement = anchor;
        this.generateAccessor(anchor);
        const end = Math.min(node.length, start + limit) - 1;
        const label = document.createElement('span');
        label.classList.add('json-node-label');
        label.appendChild(document.createTextNode('[' + start + ' ... ' + end + ']'));
        anchor.appendChild(label);
        stubElement.appendChild(anchor);
        anchor.addEventListener('click', async (e)=>{
            e.preventDefault();
            if (stubElement.isNodeOpen()) this.closePaginationStub(stubElement, true);
            else this.openPaginationStub(stubElement, node, await this.getChildNodes(node.path, start, limit), true);
        });
        stubElement.isNodeOpen = ()=>{
            return anchor.classList.contains('json-node-open');
        };
        stubElement.openNode = async ()=>{
            if (!stubElement.isNodeOpen()) {
                await this.openPaginationStub(stubElement, node, await this.getChildNodes(node.path, start, limit));
                return true;
            }
            return false;
        };
        stubElement.closeNode = async ()=>{
            if (stubElement.isNodeOpen()) {
                this.closePaginationStub(stubElement);
                return true;
            }
            return false;
        };
        stubElement.toggleNode = ()=>{
            if (stubElement.isNodeOpen()) return stubElement.closeNode();
            else return stubElement.openNode();
        };
        return stubElement;
    }
    closePaginationStub(stubElement, dispatchEvent = false) {
        if (stubElement.childrenElement) {
            stubElement.headerElement.classList.remove('json-node-open');
            stubElement.removeChild(stubElement.childrenElement);
            stubElement.childrenElement = null;
            if (dispatchEvent) this.dispatchNodeEvent('closeStub', stubElement);
        }
    }
    openPaginationStub(stubElement, node, nodes, dispatchEvent = false) {
        stubElement.headerElement.classList.add('json-node-open');
        const children = document.createElement('div');
        children.classList.add('json-node-children');
        stubElement.childrenElement = children;
        this.addChildNodes(nodes, children, node.type === 'array' ? this.options.collapseSameValue : Infinity);
        stubElement.appendChild(children);
        if (dispatchEvent) this.dispatchNodeEvent('openStub', stubElement);
    }
    addChildNodes(nodes, parent, collapseSameValue) {
        let lastValue;
        let sameValueCount = 0;
        nodes.forEach((node, i)=>{
            if (node.type !== 'object' && node.type !== 'array' && lastValue === node.value) {
                sameValueCount++;
                if (sameValueCount >= collapseSameValue) return;
            } else if (sameValueCount >= collapseSameValue) {
                parent.appendChild(this.getCollapseIndicator(sameValueCount));
                parent.appendChild(this.getNodeElement(nodes[i - 1]));
                sameValueCount = 0;
            } else sameValueCount = 0;
            parent.appendChild(this.getNodeElement(node));
            lastValue = node.value;
        });
        if (sameValueCount >= collapseSameValue) {
            parent.appendChild(this.getCollapseIndicator(sameValueCount - collapseSameValue));
            parent.appendChild(this.getNodeElement(nodes[nodes.length - 1]));
        }
    }
    getCollapseIndicator(count) {
        const element = document.createElement('div');
        element.classList.add('json-node-collapse');
        element.appendChild(document.createTextNode('... [' + count + '] ...'));
        return element;
    }
    getNodeHeader(node) {
        const element = document.createElement('div');
        element.classList.add('json-node-header');
        element.classList.add('json-node-' + node.type);
        const keyHighlightPattern = this.currentArea === 'all' || this.currentArea === 'keys' ? this.currentPattern : null;
        const valueHighlightPattern = this.currentArea === 'all' || this.currentArea === 'values' ? this.currentPattern : null;
        if (node.type === 'object' || node.type === 'array') {
            const anchor = document.createElement('a');
            anchor.classList.add('json-node-toggler');
            anchor.href = 'javascript:';
            if (node.length) {
                this.attachClickToggleListener(anchor);
                this.generateAccessor(anchor);
            }
            this.generateLabel(anchor, node, keyHighlightPattern);
            this.generateTypeInfo(anchor, node);
            element.appendChild(anchor);
        } else {
            this.generateLabel(element, node, keyHighlightPattern);
            this.generateValue(element, node, valueHighlightPattern);
            this.generateTypeInfo(element, node);
        }
        this.generateLinks(element, node);
        return element;
    }
    generateAccessor(parent) {
        const span = document.createElement('span');
        span.classList.add('json-node-accessor');
        parent.appendChild(span);
    }
    generateTypeInfo(parent, node) {
        const typeInfo = document.createElement('span');
        typeInfo.classList.add('json-node-type');
        if (node.type === 'object') typeInfo.appendChild(document.createTextNode('Object(' + node.length + ')'));
        else if (node.type === 'array') typeInfo.appendChild(document.createTextNode('Array[' + node.length + ']'));
        else if (node.type === 'Binary') typeInfo.appendChild(document.createTextNode('Binary(' + node.length + ')'));
        else typeInfo.appendChild(document.createTextNode(node.type));
        parent.appendChild(typeInfo);
    }
    generateLabel(parent, node, highlightPattern) {
        if (!node.path.length) return;
        const label = document.createElement('span');
        label.classList.add('json-node-label');
        if (this.options.labelAsPath && node.path.length > 1) {
            const prefix = document.createElement('span');
            prefix.classList.add('json-node-label-prefix');
            prefix.appendChild(document.createTextNode(node.path.slice(0, node.path.length - 1).join('.') + '.'));
            label.appendChild(prefix);
        }
        label.appendChild(this.getHighlightedText(node.path[node.path.length - 1], highlightPattern));
        parent.appendChild(label);
        parent.appendChild(document.createTextNode(': '));
    }
    generateValue(parent, node, highlightPattern) {
        const valueText = this.getValueToRender(node);
        const valueElement = document.createElement('span');
        valueElement.classList.add('json-node-value');
        valueElement.appendChild(this.getHighlightedText(valueText, highlightPattern));
        parent.appendChild(valueElement);
    }
    getValueToRender(node) {
        if ([
            'Date',
            'ObjectId',
            'RegExp'
        ].includes(node.type)) return node.value;
        if (node.type === 'Binary' && node.value.base64) return JSON.stringify(node.value.base64);
        return JSON.stringify(node.value);
    }
    getLabelNode(label) {
        if (label instanceof Node) return label;
        return document.createTextNode(label);
    }
    generateLinks(parent, node) {
        if (this.isOpenableNode(node) && this.options.linkLabelExpandAll) {
            const link = document.createElement('a');
            link.classList.add('json-node-link');
            link.href = 'javascript:';
            link.appendChild(this.getLabelNode(this.options.linkLabelExpandAll));
            link.addEventListener('click', (e)=>{
                e.preventDefault();
                const nodeElement = this.findNodeElement(parent);
                if (nodeElement && this.isOpenableNode(nodeElement.jsonNode)) this.openAll(nodeElement, Infinity, 'first', true);
            });
            parent.appendChild(link);
        }
        if (node.path.length && this.options.linkLabelCopyPath) {
            const link = document.createElement('a');
            link.classList.add('json-node-link');
            link.href = 'javascript:';
            link.appendChild(this.getLabelNode(this.options.linkLabelCopyPath));
            link.addEventListener('click', (e)=>{
                e.preventDefault();
                const input = document.createElement('input');
                input.type = 'text';
                input.value = node.path.join('.');
                const nodeElement = this.findNodeElement(parent);
                this.dispatchNodeEvent('copyPath', nodeElement);
                parent.appendChild(input);
                input.select();
                try {
                    if (!document.execCommand('copy')) console.warn('Unable to copy path to clipboard');
                } catch (e) {
                    console.error('Unable to copy path to clipboard', e);
                }
                parent.removeChild(input);
            });
            parent.appendChild(link);
        }
        if (typeof this.options.addLinksHook === 'function') for (const element of this.options.addLinksHook(node))parent.appendChild(element);
    }
    findNodeElement(el) {
        while(el && !el['jsonNode'])el = el.parentElement;
        return el;
    }
}






const $bd79623745b6affc$var$demoData = {
    simpleData: {
        element1: 'str',
        element2: 1234,
        element3: [
            23,
            43,
            true,
            false,
            null,
            {
                name: 'special'
            },
            {}
        ],
        element4: [],
        element5: "this should be some long text\nwith line break.\nIt shows how long text is handled in the Big JSON Viewer. Not everything is rendered at once, only parts of it to keep the performance high. The limit is set by default to 250 characters.This part of the text is only to make sure that we go over that limit and see how it works in practice. ",
        element6: {
            name: 'Hero',
            age: 32,
            birthday: {
                year: 1986,
                month: 4,
                day: 30
            }
        },
        element7: [
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ]
    },
    jsData: {
        element1: 'str',
        element2: 1234,
        element3: [
            23,
            43,
            true,
            false,
            null,
            {
                name: 'special'
            },
            {}
        ],
        element4: [],
        element5: 'this should be some long text\nwith line break',
        element6: {
            name: 'Hero',
            age: 32,
            birthday: {
                year: 1986,
                month: 4,
                day: 30
            }
        },
        element7: [
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ],
        element8: {
            un: undefined,
            nu: null
        }
    },
    extendedJson: {
        binaryData: {
            $binary: {
                base64: "dGhpcyBzaG91bGQgYmUgc29tZSBsb25nIHRleHRcbndpdGggbGluZSBicmVhay5cbkl0IHNob3dzIGhvdyBsb25nIHRleHQgaXMgaGFuZGxlZCBpbiB0aGUgQmlnIEpTT04gVmlld2VyLiBOb3QgZXZlcnl0aGluZyBpcyByZW5kZXJlZCBhdCBvbmNlLCBvbmx5IHBhcnRzIG9mIGl0IHRvIGtlZXAgdGhlIHBlcmZvcm1hbmNlIGhpZ2guIFRoZSBsaW1pdCBpcyBzZXQgYnkgZGVmYXVsdCB0byAyNTAgY2hhcmFjdGVycy5UaGlzIHBhcnQgb2YgdGhlIHRleHQgaXMgb25seSB0byBtYWtlIHN1cmUgdGhhdCB3ZSBnbyBvdmVyIHRoYXQgbGltaXQgYW5kIHNlZSBob3cgaXQgd29ya3MgaW4gcHJhY3RpY2Uu",
                subType: '00'
            }
        },
        dateCanonical: {
            $date: {
                $numberLong: '1704067200000'
            }
        },
        dateRelaxed: {
            $date: '2024-01-01T12:00:00Z'
        },
        numbers: {
            int32: {
                $numberInt: '42'
            },
            int32Relaxed: 42,
            int64: {
                $numberLong: '1234567890123'
            },
            int64Relaxed: 1234567890123,
            decimal128: {
                $numberDecimal: '12345.6789'
            }
        },
        regex: {
            $regularExpression: {
                pattern: '^abc',
                options: 'i'
            }
        },
        timestamp: {
            $timestamp: {
                t: 1627846267,
                i: 1
            }
        },
        minKey: {
            $minKey: 1
        },
        maxKey: {
            $maxKey: 1
        },
        objectId: {
            $oid: '507f1f77bcf86cd799439011'
        }
    },
    largeData: function() {
        const list = new Array(Math.floor(Math.random() * 1000));
        for(let i = 0; i < list.length; i++){
            list[i] = Math.random();
            if (list[i] < 0.2) list[i] = 'hey ' + list[i];
            if (list[i] > 0.8) {
                list[i] = {};
                const entries = Math.floor(Math.random() * 1000);
                for(let j = 0; j < entries; j++)list[i]['entry-' + j] = Math.random();
            }
        }
        return list;
    }()
};
const $bd79623745b6affc$var$codeElement = document.getElementById('code');
const $bd79623745b6affc$var$viewerElement = document.getElementById('viewer');
const $bd79623745b6affc$var$pathsElement = document.getElementById('paths');
const $bd79623745b6affc$var$copiedElement = document.getElementById('copied');
const $bd79623745b6affc$var$searchElement = document.getElementById('search');
const $bd79623745b6affc$var$searchInfoElement = document.getElementById('searchInfo');
let $bd79623745b6affc$var$viewer = null;
let $bd79623745b6affc$var$rootNode = document.getElementById('rootNode');
$bd79623745b6affc$var$querySelectorArray('[data-load]').forEach((link)=>{
    const load = link.getAttribute('data-load');
    if ($bd79623745b6affc$var$demoData[load] && !link.loadListener) {
        link.loadListener = true;
        link.addEventListener('click', (e)=>{
            e.preventDefault();
            $bd79623745b6affc$var$loadStructureData($bd79623745b6affc$var$demoData[load], load === 'jsData');
        });
    }
});
$bd79623745b6affc$var$codeElement.addEventListener('input', (e)=>{
    console.log('show data based on input');
    $bd79623745b6affc$var$showData($bd79623745b6affc$var$codeElement.value);
});
$bd79623745b6affc$var$searchElement.addEventListener('input', async (e)=>{
    if ($bd79623745b6affc$var$searchElement.value.length >= 2) {
        const cursor = await $bd79623745b6affc$var$viewer.openBySearch(new RegExp($bd79623745b6affc$var$searchElement.value, 'i'));
        $bd79623745b6affc$var$searchInfoElement.textContent = cursor.matches.length + ' matches';
        $bd79623745b6affc$var$searchInfoElement.appendChild(document.createTextNode(' '));
        const prevBtn = $bd79623745b6affc$var$searchInfoElement.appendChild(document.createElement('a'));
        prevBtn.href = 'javascript:';
        prevBtn.addEventListener('click', (e)=>{
            e.preventDefault();
            cursor.previous();
        });
        prevBtn.textContent = 'Prev';
        $bd79623745b6affc$var$searchInfoElement.appendChild(document.createTextNode(' '));
        const nextBtn = $bd79623745b6affc$var$searchInfoElement.appendChild(document.createElement('a'));
        nextBtn.href = 'javascript:';
        nextBtn.addEventListener('click', (e)=>{
            e.preventDefault();
            cursor.next();
        });
        nextBtn.textContent = 'Next';
    } else {
        await $bd79623745b6affc$var$rootNode.closeNode();
        $bd79623745b6affc$var$viewer.openBySearch(null);
        $bd79623745b6affc$var$searchInfoElement.textContent = '';
    }
});
$bd79623745b6affc$var$loadStructureData($bd79623745b6affc$var$demoData.simpleData);
async function $bd79623745b6affc$var$loadStructureData(structure, jsData = false) {
    if (jsData) {
        $bd79623745b6affc$var$codeElement.style.display = 'none';
        await $bd79623745b6affc$var$showData(structure, jsData);
    } else {
        const text = JSON.stringify(structure, null, 2);
        $bd79623745b6affc$var$codeElement.style.display = '';
        $bd79623745b6affc$var$codeElement.value = text;
        await $bd79623745b6affc$var$showData(text, jsData);
    }
    $bd79623745b6affc$var$showPaths();
}
async function $bd79623745b6affc$var$showData(data, jsData = false) {
    const index = 'showDataIndex' in $bd79623745b6affc$var$viewerElement ? ++$bd79623745b6affc$var$viewerElement['showDataIndex'] : $bd79623745b6affc$var$viewerElement['showDataIndex'] = 0;
    if ($bd79623745b6affc$var$viewerElement.children.length) $bd79623745b6affc$var$viewerElement.removeChild($bd79623745b6affc$var$viewerElement.children[0]);
    if ($bd79623745b6affc$var$viewer) $bd79623745b6affc$var$viewer.destroy();
    try {
        let _viewer;
        if (jsData) _viewer = await (0, $0096928a09a25e8f$export$6efa9165c4ad4d70).fromObject(data);
        else _viewer = await (0, $0096928a09a25e8f$export$6efa9165c4ad4d70).fromData(data, {
            showExtendedJson: true
        });
        if ($bd79623745b6affc$var$viewerElement['showDataIndex'] !== index) {
            _viewer.destroy();
            return;
        }
        $bd79623745b6affc$var$viewer = _viewer;
        $bd79623745b6affc$var$rootNode = $bd79623745b6affc$var$viewer.getRootElement();
        $bd79623745b6affc$var$rootNode.id = 'rootNode';
        $bd79623745b6affc$var$viewerElement.appendChild($bd79623745b6affc$var$rootNode);
        await $bd79623745b6affc$var$rootNode.openAll(1);
        $bd79623745b6affc$var$setupRootNode();
    } catch (e) {
        console.error('BigJsonViewer error', e);
        const errEl = document.createElement('div');
        errEl.classList.add('alert', 'alert-danger');
        errEl.appendChild(document.createTextNode(e.toString()));
        $bd79623745b6affc$var$viewerElement.appendChild(errEl);
    }
}
function $bd79623745b6affc$var$setupRootNode() {
    const listener = (e)=>{
        console.log('event', e.type);
        $bd79623745b6affc$var$showPaths();
    };
    $bd79623745b6affc$var$rootNode.addEventListener('openNode', listener);
    $bd79623745b6affc$var$rootNode.addEventListener('closeNode', listener);
    $bd79623745b6affc$var$rootNode.addEventListener('openedNodes', listener);
    $bd79623745b6affc$var$rootNode.addEventListener('openStub', listener);
    $bd79623745b6affc$var$rootNode.addEventListener('closeStub', listener);
    $bd79623745b6affc$var$rootNode.addEventListener('copyPath', (e)=>{
        const node = e.target;
        $bd79623745b6affc$var$copiedElement.value = node.jsonNode.path.join('.');
    });
}
function $bd79623745b6affc$var$showPaths() {
    if (!$bd79623745b6affc$var$rootNode || !$bd79623745b6affc$var$rootNode.getOpenPaths) return;
    $bd79623745b6affc$var$pathsElement.value = $bd79623745b6affc$var$rootNode.getOpenPaths().map((path)=>path.join('.')).join('\n');
}
function $bd79623745b6affc$var$querySelectorArray(selector) {
    const list = document.querySelectorAll(selector);
    const result = [];
    for(let i = 0; i < list.length; i++)result.push(list[i]);
    return result;
}


//# sourceMappingURL=docs-src.be048dda.js.map
